/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceSessionState } from '../../models/voice-session-state';

export interface GetVoiceSessionState$Params {
  organizationSiteKey: KeyType;
  voiceSessionKey: KeyType;
}

export function getVoiceSessionState(http: HttpClient, rootUrl: string, params: GetVoiceSessionState$Params, context?: HttpContext): Observable<StrictHttpResponse<VoiceSessionState>> {
  const rb = new RequestBuilder(rootUrl, getVoiceSessionState.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('voiceSessionKey', params.voiceSessionKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoiceSessionState>;
    })
  );
}

getVoiceSessionState.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions/{voiceSessionKey}/state';
